export const RealEstateInterest = {
	bindings: {
		kNumber: '<',
		sendInterest: '&',
		interestResponse: '<'
	},
	templateUrl: 'property-interest.html',
	controller: class RealEstateInterest {
		constructor() {
			'ngInject';
			this.model = {};
		}
		$onChanges(changes) {
			if (changes.kNumber && this.kNumber) {
				this.theKNuber = this.kNumber;
			}
			if (changes.interestResponse) {
				this.response = angular.copy(this.interestResponse);
			}
		}

		send() {
			this.sendInterest({
				$event: {
					interest: this.model.interest
				}
			});
		}
	}
};
